<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4 22.4 12 21l3.55-3.55-8.5-8.5L3.5 12.5l-1.4-1.4 1.4-1.45-1.4-1.4 2.1-2.1L2.8 4.7l1.4-1.4 1.45 1.4 2.1-2.1L9.15 4l1.45-1.4L12 4 8.45 7.55l8.5 8.5 3.55-3.55 1.4 1.4-1.4 1.45 1.4 1.4-2.1 2.1 1.4 1.45-1.4 1.4-1.45-1.4-2.1 2.1-1.4-1.4-1.45 1.4Z"
    />
  </svg>
</template>
